import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTrades } from "../../store/actions/councilActions/trade";

const TradeSubtradeSelector = ({ data, setData, approvedTrades }) => {
  const [subTrades, setSubtrades] = useState(null);
  const { admin } = useSelector((state) => state);
  const { trades } = admin;
  const dispatch = useDispatch();
  useEffect(() => {
    if (!trades) {
      dispatch(getTrades());
    }
  }, []);

  // Center side passes the trades the council approved for it. Every trade is
  // still SHOWN, but only approved ones can be picked - the rest are greyed out
  // and marked "Not Approved". Admin / public / a center approved before this
  // feature pass nothing, so every trade stays selectable (no restriction).
  const gate = Array.isArray(approvedTrades) && approvedTrades.length > 0;
  const approvedIds = gate ? approvedTrades.map((t) => Number(t.id)) : [];
  const isApproved = (id) => !gate || approvedIds.includes(Number(id));

  useEffect(() => {
    if (trades) {
      const subtrades =
        trades.find((trade) => trade.id == data.trade)?.subtrade || [];
      setSubtrades(subtrades);
    }
  }, [data.trade, data.trade]);

  return (
    <>
      <div class="col-md-12">
        <div class="boxlabel">
          <p>Trade </p>
          <select
            class="form-control"
            name="trade"
            value={data.trade}
            onChange={(e) =>
              setData({
                ...data,
                trade: e.target.value,
                sub_trade: "",
              })
            }
            required
          >
            <option disabled selected value="">
              Select Trade
            </option>
            {!trades ? (
              <option value="" disabled>
                Loading...
              </option>
            ) : trades && trades.length > 0 ? (
              trades.map((trade, index) => (
                <option
                  value={trade.id}
                  key={index}
                  disabled={!isApproved(trade.id)}
                  style={
                    isApproved(trade.id)
                      ? { color: "#0a7d2c", fontWeight: 600 }
                      : { color: "#9ca3af" }
                  }
                >
                  {trade.name}
                  {!isApproved(trade.id) ? " (Not Approved)" : ""}
                </option>
              ))
            ) : (
              <option disabled>No Trade Found</option>
            )}
          </select>
        </div>
      </div>
      {data.trade && (
        <div class="col-md-12">
          <div class="boxlabel">
            <p>Sub Trade</p>
            <select
              class="form-control"
              name="trade"
              value={data.sub_trade}
              onChange={(e) =>
                setData({
                  ...data,
                  sub_trade: e.target.value,
                  course: "",
                })
              }
              required
            >
              <option disabled selected value="">
                Select Sub Trade
              </option>
              {!subTrades ? (
                <option value="" disabled>
                  Loading...
                </option>
              ) : subTrades.length > 0 ? (
                subTrades.map((trade, index) => (
                  <option value={trade.id} key={index}>
                    {trade.name}
                  </option>
                ))
              ) : (
                <option disabled value={""} selected>
                  No Sub Trade Found
                </option>
              )}
            </select>
          </div>
        </div>
      )}
    </>
  );
};

export default TradeSubtradeSelector;
